import React from "react";
import styled from "styled-components";
import Checkbox from "manifest-components/src/Inputs/Checkbox";

const StyledCheckboxMenuItem = styled.li`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 30px 1fr;
  grid-gap: 10px;
  align-items: center;
`;

export type CheckboxMenuItemProps = {
  onClick: () => any;
  enabled: boolean;
};

const CheckboxMenuItem: React.FC<CheckboxMenuItemProps> = ({ onClick, children, enabled }) => {
  return (
    <StyledCheckboxMenuItem role="button" onClick={onClick}>
      <Checkbox name="checkBoxMenuItem" checked={enabled} />
      <span>{children}</span>
    </StyledCheckboxMenuItem>
  );
};

export default CheckboxMenuItem;
